import React from 'react';
import {TableRow, TableCell} from 'material-ui/Table';
import classNames from 'classnames';
import TableRolesPermissionsCheckboxes from './TableRolesPermissionsCheckboxes';

const TableRolesPermissionsInputs = ({perm, rolesPermissions, classes, changeRolePermission, roles}) => {

    const combinedClassNames = classNames(classes.tableCell, classes.permissionsRows);

    return (
        <TableRow hover={true}>
            <TableCell className={combinedClassNames}>{perm.permission_name}</TableCell>
            {roles.map(role =>
                <TableRolesPermissionsCheckboxes
                    key={role.id}
                    role={role}
                    perm={perm}
                    rolesPermissions={rolesPermissions}
                    changeRolePermission={changeRolePermission}
                    classes={classes}
                />
            )}
        </TableRow>
    )
}

export default TableRolesPermissionsInputs;


// WEBPACK FOOTER //
// ./src/containers/roles/forms/TableRolesPermissionsInputs.jsx